import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xjdcstmhf: FaireProductEntity = {
  token: "p_2xjdcstmhf",
  type: "product",
  name: "Organic Passion Fruit Nectar - Emile Vergeois - Glass Bottle",
  brandToken: "b_puxke2dnj7",
  brandName: "Apricot & Honey Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/330e0d2aca588f3d2ea0e7815b98fd1ed13148c05f71bb735cad9c4493e2bfc0.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.08,
  description:
    "Indulge in the exquisite taste of Apricot & Honey Gourmet's Organic Passion Fruit Nectar. USDA certified, this nectar captures the exotic flavor of passion fruit in a convenient glass bottle. Enjoy it year-round as a refreshing drink, a unique cocktail ingredient, or a delightful addition to your culinary creations. As a family-operated importer from Maryland, we're committed to bringing you the finest artisanal French food and beverages. Experience the gourmet taste of France with our Organic Passion Fruit Nectar.",
  tags: [],
  msrpDollars: 14.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:32.377Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
